import React from 'react'
import { HERO_DATA } from '../../helpers/constants'
import { Hero } from './styles'
import ContactUs from '../ContactUs/Button'
type Props = {
  section: string
}

const Component = ({ section }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { title, subTitle, site, location, image, height, photoCourtesy } = HERO_DATA[section]
  return (
    <Hero data-type={section} data-style='hero'>
      <div data-type='overlay' />
      <picture data-type='image'>
        <img
          width='1440'
          height={height}
          itemProp='image'
          src={image}
          alt='hero'
          role='presentation'
          data-type='image'
        />
      </picture>
      <div data-type='header'>
        <h1>{title}</h1>
        <div data-type='sub-section'>
          <p data-type='sub-title'>{subTitle}</p>
          <ContactUs dataStyle='hero' />
        </div>
      </div>
      <div data-type='site-section'>
        <p data-type='site-name'>{site}</p>
        <p data-type='location'>{location}</p>
        <p data-type='photo-courtesy'>{photoCourtesy}</p>
      </div>
    </Hero>
  )
}

export default Component